import * as yup from "yup";

export const tenantUserFormSchema = yup.object().shape({
  userFirstName: yup.string().required("Please enter first name"),
  userLastName: yup.string().required("Please enter first name"),
  userEmail: yup
    .string()
    .required("Please enter first name")
    .email("Please enter valid email address"),
  userRole: yup.string().required("Please select user role"),
});
